import { render, staticRenderFns } from "./NicklistUser.vue?vue&type=template&id=ab36ecfe&"
import script from "./NicklistUser.vue?vue&type=script&lang=js&"
export * from "./NicklistUser.vue?vue&type=script&lang=js&"
import style0 from "./NicklistUser.vue?vue&type=style&index=0&id=ab36ecfe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports